import axios from "axios";

// Cached fetch of public app config so admin-set AdSense values (no rebuild
// needed) reach AdSlot. Falls back to build-time env vars.
let _promise = null;

export function getAdsConfig() {
  if (!_promise) {
    _promise = axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/config/public`)
      .then((r) => ({
        client: r.data?.adsense_client || process.env.REACT_APP_ADSENSE_CLIENT || "",
        slot: r.data?.adsense_slot || "",
      }))
      .catch(() => ({
        client: process.env.REACT_APP_ADSENSE_CLIENT || "",
        slot: "",
      }));
  }
  return _promise;
}
